/**
 * Storage key for the operator's active-location selection.
 *
 * Persisted client-side (localStorage) so a supervisor's chosen operational
 * location survives reloads, and read by `@jq4race/api-client` to inject the
 * `X-Location-Id` header on every request (FR-20).
 *
 * Lives in `@jq4race/shared` — the one package both `apps/admin` and
 * `@jq4race/api-client` already depend on — so every reader/writer imports
 * the same literal instead of re-declaring it locally.
 */
export const ACTIVE_LOCATION_STORAGE_KEY = 'jq4race:active_location_id';
//# sourceMappingURL=active-location.js.map